/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';

import Avatar from '@atlaskit/avatar';
import { token } from '@atlaskit/tokens';

import { TalentSearchResultIcon } from '../../constants/icons/talent';

type TalentUserAvatarProps = {
	src?: string;
};

const styles = cssMap({
	container: {
		position: 'relative',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& > svg': {
			position: 'absolute',
			bottom: '0px',
			right: '0px',
			height: '12px',
			width: '12px',
			borderColor: token('elevation.surface.overlay'),
			backgroundColor: token('elevation.surface.overlay'),
			borderWidth: token('border.width'),
			borderStyle: 'solid',
			borderRadius: '30%',
		},
	},
});

export const TalentUserAvatar = ({ src }: TalentUserAvatarProps) => {
	return (
		<span css={[styles.container]}>
			<Avatar src={src} />
			<TalentSearchResultIcon />
		</span>
	);
};
